import _ from 'lodash'
import * as NUMBER from 'constant/number'

export const buildCategory = (object) => {
  const categories = []
  const defaultSelectedKeys = []
  object.results.map((article, index) => {
    if (_.isEmpty(article.sub_category)) {
      return article.category.map((sub) => {
        const exists = _.findIndex(categories, { name: sub.name, uuid: sub.uuid })
        if (exists < NUMBER.ZERO) {
          defaultSelectedKeys.push(sub.site_uuid, sub.uuid)
          return categories.push({ name: sub.name, site_name: article.site_name, site_uuid: article.site_uuid, uuid: sub.uuid })
        } else {
          return false
        }
      })
    } else {
      return article.sub_category.map((sub) => {
        const exists = _.findIndex(categories, { name: sub.parent_name, uuid: sub.parent_uuid })
        if (exists < NUMBER.ZERO) {
          defaultSelectedKeys.push(sub.site_uuid, sub.uuid, sub.parent_uuid)
          return categories.push({ name: sub.parent_name, site_name: sub.site_name, site_uuid: sub.site_uuid, sub_category: [{ name: sub.name, uuid: sub.uuid }], uuid: sub.parent_uuid })
        } else {
          const subExists = _.findIndex(categories[exists].sub_category, { name: sub.name, uuid: sub.uuid })
          if (subExists < NUMBER.ZERO) {
            defaultSelectedKeys.push(sub.uuid)
            categories[exists].sub_category.push(sub)
          }
          return false
        }
      })
    }
  })

  return { categories, defaultSelectedKeys }
}

export const filterResultsBuilder = async (object, filterValues) => {
  const chosenArticles = await object.results.map((article, index) => {
    let children = false
    if (_.isEmpty(article.sub_category)) {
      article.category.map((category, index) => {
        const exists = filterValues.includes(category.uuid)
        if (!children) {
          children = exists
        }
        return children
      })
    } else {
      article.sub_category.map((subCategory, index) => {
        const exists = filterValues.includes(subCategory.uuid)
        if (!children) {
          children = exists
        }
        return children
      })
    }

    if (children) {
      return article
    }
    return null
  })
  return chosenArticles
}
